import React from "react";
import { createContext } from "react";

export const FormikContext = createContext(null)

function FormikProvider(props){
    return(
        // eslint-disable-next-line react/react-in-jsx-scope
        <FormikContext.Provider value={props.formik}>
            {props.children}
        </FormikContext.Provider>
    )
}

export default FormikProvider